"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var ChariotResource_1 = require("./ChariotResource");
var api_1 = require("../api");
var Errors_1 = require("../../helpers/Errors");
var Site = /** @class */ (function (_super) {
    __extends(Site, _super);
    function Site(apiSite, chariot) {
        var _this = _super.call(this, apiSite, chariot) || this;
        _this.equipment = [];
        _this.equipmentEmpty = false;
        _this._ = (0, class_transformer_1.plainToClass)(api_1.ApiSite, apiSite);
        return _this;
    }
    Site.prototype.getDisplayName = function () {
        if (this._.display_name && this._.display_name.length > 0) {
            return this._.display_name;
        }
        return this._.name;
    };
    Site.prototype.getDisplayAddress = function () {
        return [
            this._.street_line_1,
            this._.street_line_2,
            this._.locality,
            [this._.region, this._.postal_code]
                .filter(function (segment) { return !!segment; }).join(" ")
        ].filter(function (segment) { return !!segment; }).join(", ");
    };
    Site.prototype.getTimezone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!this._.longitude || !this._.latitude) {
                            throw new Errors_1.ValidationError("Latitude and Longitude were not found on the site.");
                        }
                        if (this.timezoneResponse)
                            return [2 /*return*/, this.timezoneResponse];
                        _a = this;
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                url: "https://vip.timezonedb.com/v2.1/get-time-zone",
                                authenticated: false,
                                params: {
                                    key: "XXRWIIUM7RDR",
                                    format: "json",
                                    by: "position",
                                    fields: "abbreviation,dst,gmtOffset",
                                    lat: this._.latitude,
                                    lng: this._.longitude
                                }
                            })];
                    case 1:
                        _a.timezoneResponse = _b.sent();
                        return [2 /*return*/, this.timezoneResponse];
                    case 2:
                        e_1 = _b.sent();
                        this.chariot.logger.catch(e_1, "Cannot retrieve timezone data");
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getWeather = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!this._.longitude || !this._.latitude) {
                            throw new Errors_1.ValidationError("Latitude and Longitude were not found on the site.");
                        }
                        if (this.weatherResponse)
                            return [2 /*return*/, this.weatherResponse];
                        _a = this;
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/weather",
                                params: {
                                    lat: this._.latitude,
                                    lng: this._.longitude
                                }
                            })];
                    case 1:
                        _a.weatherResponse = _b.sent();
                        return [2 /*return*/, this.weatherResponse];
                    case 2:
                        e_2 = _b.sent();
                        this.chariot.logger.catch(e_2, "Cannot retrieve weather data");
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to get status for non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Site.statusCache.get(this._.id)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        this.chariot.logger.catch(e_3, "Failed to retrieve site status");
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getStatusLog = function (from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var logs, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to get status log for non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.RestApi.unfurlStasisApiPagination({
                                path: "/stasis/status/logs",
                                params: {
                                    site_id: this._.id,
                                    from_date: from === null || from === void 0 ? void 0 : from.toISOString(),
                                    to_date: to === null || to === void 0 ? void 0 : to.toISOString()
                                }
                            })];
                    case 1:
                        logs = _a.sent();
                        return [2 /*return*/, logs];
                    case 2:
                        e_4 = _a.sent();
                        this.chariot.logger.catch(e_4, "Failed to retrieve site status");
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getDownPoints = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to get down points for non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/stasis/points",
                                params: {
                                    client_id: this._.client_id,
                                    site_id: this._.id,
                                    page_size: 9999
                                }
                            })];
                    case 1:
                        response = (_a.sent()).results;
                        return [2 /*return*/, response];
                    case 2:
                        e_5 = _a.sent();
                        this.chariot.logger.catch(e_5, "Failed to retrieve down points for site");
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getSiteGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var group_ids, possibly_mixed_site_groups, site_groups, _i, possibly_mixed_site_groups_1, site_group;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        group_ids = this._.group_ids || [];
                        return [4 /*yield*/, Promise.all(group_ids.map(function (group_id) { return __awaiter(_this, void 0, void 0, function () {
                                var e_6;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.chariot.SiteGroup.get(group_id)];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            e_6 = _a.sent();
                                            if (e_6 instanceof Errors_1.EntityNotFoundError)
                                                return [2 /*return*/, null];
                                            throw e_6;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        possibly_mixed_site_groups = _a.sent();
                        site_groups = [];
                        for (_i = 0, possibly_mixed_site_groups_1 = possibly_mixed_site_groups; _i < possibly_mixed_site_groups_1.length; _i++) {
                            site_group = possibly_mixed_site_groups_1[_i];
                            if (site_group)
                                site_groups.push(site_group);
                        }
                        return [2 /*return*/, site_groups];
                }
            });
        });
    };
    Site.prototype.assignToSiteGroup = function (siteGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!siteGroup || !siteGroup._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to assign site to non-existent site group. Try SiteGroup.save()");
                        }
                        return [4 /*yield*/, this.update({
                                group_ids: (this._.group_ids || []).concat(siteGroup._.id)
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_7 = _a.sent();
                        this.chariot.logger.catch(e_7, "Failed to assign site to site group");
                        throw e_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body, apiSite, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.chariot.verifyWriteAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.validateApiResource()];
                    case 2:
                        _a.sent();
                        body = this._;
                        delete body.equipment;
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/sites",
                                method: "PUT",
                                body: body
                            })];
                    case 3:
                        apiSite = _a.sent();
                        if (this._.id) {
                            this.chariot.logger.log("Site successfully updated");
                        }
                        else {
                            this.chariot.logger.log("Site successfully created");
                        }
                        this._ = (0, class_transformer_1.plainToClass)(api_1.ApiSite, __assign(__assign({}, this._), apiSite));
                        return [2 /*return*/, this];
                    case 4:
                        e_8 = _a.sent();
                        this.chariot.logger.catch(e_8, "Failed to save site");
                        throw e_8;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.update = function (apiSite) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._ = (0, class_transformer_1.plainToClass)(api_1.ApiSite, __assign(__assign({}, this._), apiSite));
                        return [4 /*yield*/, this.save()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Site.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.chariot.verifyAdminAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/clients/internal/sites/".concat(this._.id),
                                method: "DELETE"
                            })];
                    case 2:
                        _a.sent();
                        this.chariot.Site.__removeFromCache(this);
                        return [3 /*break*/, 4];
                    case 3:
                        e_9 = _a.sent();
                        this.chariot.logger.catch(e_9, "Failed to delete site");
                        throw e_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.unsafe__hardDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.chariot.verifyAdminAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/clients/internal/sites/".concat(this._.id),
                                method: "DELETE",
                                params: {
                                    force: "true"
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.chariot.Site.__removeFromCache(this);
                        return [3 /*break*/, 4];
                    case 3:
                        e_10 = _a.sent();
                        this.chariot.logger.catch(e_10, "Failed to hard delete site");
                        throw e_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Site.prototype.getEquipment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve equipment for a site that does not exist. Try Site.save()");
                        }
                        if (this.equipment.length > 0 || this.equipmentEmpty)
                            return [2 /*return*/, this.equipment];
                        if (!(this._.equipment && this._.equipment.length > 0)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, Promise.all(this._.equipment.map(function (equipment) { return _this.chariot.Equipment.build(equipment); }))];
                    case 1:
                        _a.equipment = _c.sent();
                        return [2 /*return*/, this.equipment];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.chariot.Equipment.list({
                                params: {
                                    site_id: this._.id
                                }
                            })];
                    case 3:
                        _b.equipment = _c.sent();
                        this.equipmentEmpty = this.equipment.length == 0;
                        return [2 /*return*/, this.equipment];
                }
            });
        });
    };
    Site.prototype.createEquipment = function (apiEquipment) {
        return __awaiter(this, void 0, void 0, function () {
            var equipment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to create equipment on non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Equipment.build(__assign(__assign({}, apiEquipment), { site_id: this._.id }))];
                    case 1:
                        equipment = _a.sent();
                        return [4 /*yield*/, equipment.save()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Site.prototype.getFloorplans = function () {
        return __awaiter(this, void 0, void 0, function () {
            var floorplans;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve floorplans for a site that does not exist. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Floorplan.list({
                                params: {
                                    site_id: this._.id
                                }
                            })];
                    case 1:
                        floorplans = _a.sent();
                        return [2 /*return*/, floorplans];
                }
            });
        });
    };
    Site.prototype.getRuleEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ruleEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve rule events for a site that does not exist. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.RuleEvent.list({
                                filters: {
                                    site_id: this._.id
                                }
                            })];
                    case 1:
                        ruleEvents = _a.sent();
                        return [2 /*return*/, ruleEvents];
                }
            });
        });
    };
    Site.prototype.getSchedules = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve schedules for a site that does not exist. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Schedule.list({
                                params: {
                                    site_id: this._.id
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Site.prototype.createSchedule = function (apiSchedule) {
        return __awaiter(this, void 0, void 0, function () {
            var schedule;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to create schedule on non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Schedule.build(__assign(__assign({}, apiSchedule), { siteId: this._.id }))];
                    case 1:
                        schedule = _a.sent();
                        return [4 /*yield*/, schedule.save()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Site.prototype.getPresets = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve presets for a site that does not exist. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Preset.list({
                                params: {
                                    site_id: this._.id
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Site.prototype.createPreset = function (apiPreset) {
        return __awaiter(this, void 0, void 0, function () {
            var preset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to create preset on non-existent site. Try Site.save()");
                        }
                        return [4 /*yield*/, this.chariot.Preset.build(__assign(__assign({}, apiPreset), { site_id: this._.id }))];
                    case 1:
                        preset = _a.sent();
                        return [4 /*yield*/, preset.save()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Site;
}(ChariotResource_1.default));
exports.default = Site;
